// extracted by mini-css-extract-plugin
export var description = "VerifyMobileStep-module--description--78087";